import React from 'react';
import '../constants/ColorCodes.css';
import ClassCanvas from '../features/classCanvas/ClassCanvas';
import TeachRTooltip from "../components/Tooltip/TeachRTooltip"

/**
 * `ClassArea` is a React functional component that represents a container for the classroom section.
 * It includes a header with the title "Classroom" and renders the `ClassCanvas` component 
 * within a styled div that uses flexbox for layout.
 *
 * @returns {JSX.Element} The rendered UI for the class area, including the title and the class canvas.
 */
const ClassArea = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ flex: 1, color: 'var(--textcolor)', backgroundColor: 'var(--background)', padding: '5px', marginLeft: '14px', overflow: 'visible' }}>
                <h2 style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-start', margin: 0 }}>
                    Classroom
                    <TeachRTooltip
                        content={
                            <div>
                                <p> Hotkeys:</p>
                                <ul>
                                    <li>q - positive impulse</li>
                                    <li>w - neutral  impulse</li>
                                    <li>e - negative impulse</li>
                                    <li>r - evoke</li>
                                    <li>s - trigger idle animation</li>
                                    <li>a - select/deselect all students</li>
                                </ul>
                            </div>
                        }
                        icon="info-sign"
                        iconColor="var(--highlight_1)"
                        tooltipDirection="bottom"
                        style={{ marginLeft: '14px' }}
                    />
                </h2>
                <ClassCanvas/>
            </div>
        </div>
    );
};

export default ClassArea;
